export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_BUTTON = "FORGOT_PASSWORD_BUTTON";
